{
  "de": {
    "employee": {
      "actions": {
        "accessProjects": "Projektzugriff verwalten",
        "cancel": "Rückgängig machen",
        "changeProfilePicture": "Profilbild ändern",
        "change_role": "Rolle ändern zu",
        "download": "Herunterladen",
        "new": "Teammitglied",
        "profilePictureFormat": "Sollte mindestens 300×300 px sein",
        "save": "Speichern",
        "searchEmployee": "Teammitglied suchen",
        "sendinvitation": "Einladung erstellen und senden",
        "submit": "Speichern",
        "undoChanges": "Rückgängig machen"
      },
      "attributes": {
        "email_address": "E-Mail",
        "email_notifications_interval": {
          "daily": "Einmal täglich (gegen Mittag)",
          "hourly": "Stündlich",
          "twice_daily": "Zweimal täglich (Morgen/Mittag)",
          "weekly": "Einmal wöchentlich (montags mittags)"
        },
        "first_name": "Vorname",
        "language": "Sprache",
        "last_name": "Nachname",
        "phone_landline": "Festnetznummer",
        "phone_mobile": "Mobilnummer",
        "profession": "Position",
        "role": "Zugriffsrechte",
        "signature_html": "Konversationssignatur",
        "status": "Status",
        "title": "Anrede"
      },
      "integrations": {
        "hide_details": "Details ausblenden",
        "last_synced_at": "Zuletzt synchronisiert am: {time}",
        "show_details": "Details anzeigen"
      },
      "labels": {
        "all_projects": "Alle Projekte",
        "confirmChangeRoleTitle": "Rolle zu {role} ändern?",
        "confirmChangeRoleToMaintainer": "Hinweis: {name} verliert den Zugriff auf alle Projekte, und alle bestehenden Benachrichtigungen werden entfernt. Sie können {name} anschließend wieder als Projektbetreuer Projekten zuweisen.",
        "confirmChangeRoleToOwner": "{name} erhält Zugriff auf alle Projekte und alle Inhalte auf der Plattform.",
        "confirmPasswordReset": "Eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts wurde gesendet. Bitte prüfen Sie Ihren Posteingang. Kontaktieren Sie uns, falls Probleme auftreten.",
        "disabled": {
          "access": "Wir gewähren allen Mitarbeitern Zugriff auf die Plattform, sobald die letzte überfällige Rechnung bezahlt wurde.",
          "contact": "Kontaktieren Sie uns",
          "overdue": "Wir haben festgestellt, dass Ihre letzte Rechnung seit Langem überfällig ist. Wir haben den Zugriff für alle Mitarbeiter auf dieser Plattform gesperrt. Partner und Kunden können weiterhin auf ihre Daten zugreifen.",
          "title": "Ihr Konto wurde deaktiviert!"
        },
        "display": "Anzeigen",
        "filters": "Filter",
        "generalNotifications": "Benachrichtigen Sie mich über",
        "has_access_to": "Hat Zugriff auf",
        "information": "Profilinformationen",
        "informationNotificationsEmail": "Erhalten Sie eine Übersicht per E-Mail, die nur Benachrichtigungen enthält, die Sie auf der Plattform noch nicht gesehen haben.",
        "informationNotificationsPlatform": "Erhalten Sie alle Benachrichtigungen in Ihrer persönlichen Übersicht oben rechts auf dem Bildschirm",
        "informationNotificationsTitle": "Entscheiden Sie, welche Art von Benachrichtigungen Sie erhalten möchten und wie",
        "its_you!": "Das sind Sie!",
        "last_login": "Letzte Anmeldung",
        "maintainerAccess": "Erfordert projektbezogenen Zugriff.",
        "name": "Name",
        "onPlatform": "Auf der Plattform",
        "ownerAccess": "Hat Zugriff auf alle Projekte und Inhalte auf der {client_name}-Plattform.",
        "password": "Passwort",
        "permissions": "Zugriffsrechte für",
        "permissionsOwnerOnly": "Als Projektbetreuer können Sie diese Aktion nicht durchführen. Bitten Sie ein Teammitglied von {client_name} mit der Rolle Inhaber, dies für Sie zu erledigen.",
        "projectMaintains": "{first_name} hat Zugriff auf die folgenden Projekte:",
        "projectMaintainsAdd": "Um Zugriff zu gewähren, wählen Sie ein Projekt aus und fügen Sie {first_name} unter „Informationen“ als Projektbetreuer hinzu.",
        "projectMaintainsNone": "hat keinen Zugriff auf Projekte.",
        "projectNotifications": "Für Projekt",
        "search_by_name_or_email": "Nach Name oder E-Mail suchen",
        "show_signature": "Signatur anzeigen",
        "signature_active": "Signatur aktiv",
        "signature_info": "Diese Signatur wird Antworten hinzugefügt, die an Kunden und Partner gesendet werden.",
        "sorting": "Sortierung",
        "viaEmail": "Per E-Mail"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Zugänglich",
          "description": "Änderungen werden automatisch gespeichert",
          "not_accessible": "Nicht zugänglich",
          "title": "Projektzugänglichkeit für {first_name} {last_name} aktualisieren"
        }
      },
      "roles": {
        "maintainer": "Projektbetreuer",
        "owner": "Inhaber"
      },
      "toasts": {
        "create": "Teammitglied wurde erstellt",
        "update": "Teammitglied wurde aktualisiert"
      },
      "validation": {
        "emailTaken": "E-Mail-Adresse wurde bereits verwendet",
        "mustBeEmailAddress": "Gültige E-Mail-Adresse erforderlich",
        "needFirstName": "Vorname erforderlich",
        "needLastName": "Nachname erforderlich",
        "requireEmailAddress": "E-Mail-Adresse erforderlich",
        "role": "Zugriffsrechte auswählen"
      }
    }
  }
}
